var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6875 10.7094V6.02088C11.6875 5.62967 12.0046 5.31254 12.3958 5.31254C12.787 5.31254 13.1042 5.62967 13.1042 6.02088V12.3959C13.1042 12.3988 13.1041 12.4017 13.1041 12.4047C13.1062 12.5843 13.0387 12.7646 12.9016 12.9016C12.7644 13.0388 12.5838 13.1064 12.404 13.1042C12.4013 13.1042 12.3986 13.1042 12.3958 13.1042H6.02083C5.62961 13.1042 5.31249 12.7871 5.31249 12.3959C5.31249 12.0047 5.62961 11.6875 6.02083 11.6875H10.7094L4.09842 5.07659C3.8283 4.80648 3.8283 4.36856 4.09842 4.09846C4.3685 3.82835 4.80645 3.82835 5.07653 4.09846L11.6875 10.7094Z",
    fill: "#E44829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowRed);
export default __webpack_public_path__ + "static/media/down-arrow-red.93973aab7298297be7f063c92ad07e3c.svg";
export { ForwardRef as ReactComponent };